import styled from 'styled-components';
import { mq, ScreenSize } from '../../styles/mq';

export const Container = styled.div`
  position: relative;
  padding: 0 2rem;
  width: 100%;
  max-width: ${ScreenSize.MD / 10}rem;
  margin: 0 auto;
  line-height: 1.35;

  ${mq.medium} {
    padding: 0 4rem;
    max-width: 740px;
  }

  ${mq.xlarge} {
    max-width: ${ScreenSize.MD / 10}rem;
  }
`;
export const ContainerBigger = styled.div`
  position: relative;
  padding: 0 1rem;
  width: 100%;
  max-width: ${ScreenSize.MD / 10}rem;
  margin: 0 auto;

  ${mq.medium} {
    padding: 0 4rem;
    max-width: calc(740px + 11rem);
  }
  ${mq.xlarge} {
    max-width: calc(${ScreenSize.MD / 10}rem + 15rem);
  }
`;
export const ContainerLarge = styled.div`
  position: relative;
  padding: 0 2rem;
  width: 100%;
  max-width: ${ScreenSize.MD / 10}rem;
  margin: 0 auto;

  ${mq.medium} {
    padding: 0 4rem;
    max-width: 740px;
  }
  ${mq.large} {
    padding: 0 4rem 0 30rem;
    max-width: calc(${ScreenSize.MD / 10}rem + 30rem);
  }
  ${mq.xlarge} {
    padding: 0 4rem 0 40rem;
    max-width: calc(${ScreenSize.MD / 10}rem + 40rem);
  }
`;

export const ParagraphContainer = styled.div`
  max-width: 905px;
  width: 100%;
`;
